/* Marche Noir custom wishlist (localStorage-based) + header reorg. */
(function () {
  if (window.__mrcWishlistBound) return;
  window.__mrcWishlistBound = true;

  var KEY = 'mrcn_wishlist_v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    window.dispatchEvent(new CustomEvent('mrcn:wishlist-changed', { detail: { list: list } }));
  }
  function indexOf(id, list) {
    list = list || read();
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].id) === String(id)) return i;
    }
    return -1;
  }
  function payloadFromButton(btn) {
    return {
      id: btn.getAttribute('data-product-id'),
      variantId: btn.getAttribute('data-variant-id'),
      title: btn.getAttribute('data-product-title'),
      url: btn.getAttribute('data-product-url'),
      image: btn.getAttribute('data-product-image'),
      price: btn.getAttribute('data-product-price'),
      savedAt: Date.now()
    };
  }
  function syncUI() {
    var list = read();
    var btns = document.querySelectorAll('.card-save-btn');
    for (var i = 0; i < btns.length; i++) {
      var id = btns[i].getAttribute('data-product-id');
      btns[i].classList.toggle('saved', indexOf(id, list) >= 0);
    }
  }

  function rewriteWishlistLinks() {
    var links = document.querySelectorAll('a[href="/apps/page/wishlist"], a[href$="/apps/page/wishlist"]');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('href', '/pages/wishlist');
    }
  }

  function reorganizeHeader() {
    var icons = document.querySelector('.header__icons');
    if (!icons || icons.getAttribute('data-mn-reorg')) return;
    var cartText = icons.querySelector('#cart-icon-bubble .header-text-desktop');
    if (cartText && /shopping bag/i.test(cartText.textContent)) {
      cartText.textContent = cartText.textContent.replace(/shopping bag/i, 'Bag');
    }
    var cartSpan = icons.querySelector('#cart-icon-bubble');
    if (cartSpan) {
      while (cartSpan && cartSpan.parentElement !== icons) cartSpan = cartSpan.parentElement;
    }
    function makeLink(href, label) {
      var a = document.createElement('a');
      a.setAttribute('href', href);
      a.className = 'header__icon mn-header-link';
      a.innerHTML = '<span class="header-text-desktop">' + label + '</span>';
      return a;
    }
    var saved = makeLink('/pages/wishlist', 'Saved');
    var login = makeLink('/account', 'Login');
    if (cartSpan && cartSpan.parentElement === icons) {
      icons.insertBefore(saved, cartSpan);
      icons.insertBefore(login, cartSpan);
    } else {
      icons.appendChild(saved);
      icons.appendChild(login);
    }
    icons.setAttribute('data-mn-reorg', '1');
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.card-save-btn');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var id = btn.getAttribute('data-product-id');
    if (!id) return;
    var list = read();
    var idx = indexOf(id, list);
    if (idx >= 0) {
      list.splice(idx, 1);
      btn.classList.remove('saved');
    } else {
      list.push(payloadFromButton(btn));
      btn.classList.add('saved');
    }
    write(list);
  }, true);

  function init() {
    syncUI();
    rewriteWishlistLinks();
    reorganizeHeader();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () { syncUI(); rewriteWishlistLinks(); reorganizeHeader(); });
  document.addEventListener('facets:grid-updated', syncUI);
  window.addEventListener('mrcn:wishlist-changed', syncUI);
  window.addEventListener('storage', function (e) { if (e.key === KEY) syncUI(); });

  window.MrcnWishlist = {
    list: read,
    remove: function (id) {
      var list = read();
      var idx = indexOf(id, list);
      if (idx >= 0) { list.splice(idx, 1); write(list); }
    },
    clear: function () { write([]); },
    count: function () { return read().length; }
  };
})();

/* Marche Noir — Search relevance fix: products only, no prefix matching. */
(function () {
  if (window.__mrcSearchFix) return;
  window.__mrcSearchFix = true;
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    var action = (f.getAttribute('action') || '');
    if (action.indexOf('/search') === -1) return;
    var pfx = f.querySelectorAll('input[name="options[prefix]"]');
    for (var i = 0; i < pfx.length; i++) { pfx[i].parentNode.removeChild(pfx[i]); }
    if (!f.querySelector('input[name="type"]')) {
      var t = document.createElement('input');
      t.type = 'hidden'; t.name = 'type'; t.value = 'product';
      f.appendChild(t);
    }
  }, true);
})();

/* Marche Noir — Predictive search fix. */
(function () {
  if (window.__mrcPredictiveFix) return;
  window.__mrcPredictiveFix = true;
  function ensureContainer() {
    var list = document.querySelectorAll('predictive-search');
    for (var i = 0; i < list.length; i++) {
      var ps = list[i];
      if (ps.querySelector('[data-predictive-search]')) continue;
      var c = document.createElement('div');
      c.className = 'predictive-search predictive-search--header mn-predictive';
      c.setAttribute('data-predictive-search', '');
      c.setAttribute('tabindex', '-1');
      var form = ps.querySelector('form');
      (form || ps).appendChild(c);
      try { ps.predictiveSearchResults = c; } catch (e) {}
      if (!ps.querySelector('.predictive-search-status')) {
        var s = document.createElement('span');
        s.className = 'predictive-search-status visually-hidden';
        s.setAttribute('role', 'status');
        ps.appendChild(s);
      }
    }
  }
  ensureContainer();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ensureContainer);
  document.addEventListener('shopify:section:load', ensureContainer);
})();

/* Marche Noir — Product page "Add to wishlist" button.
   Inserted INSIDE the buy form, right after the button group, so it sits
   directly under the Add-to-bag CTA (the info column uses flex ordering, so a
   sibling of <product-form> would drop to the bottom). Reuses the localStorage
   wishlist + the .card-save-btn handler above. */
(function () {
  if (window.__mrcPdpWishlist) return;
  window.__mrcPdpWishlist = true;
  function makeBtn() {
    var m = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) ? window.ShopifyAnalytics.meta.product : {};
    var vEl = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    var titleEl = document.querySelector('.mn-header-dt__title');
    var imgEl = document.querySelector('#MainContent .product__media img, #MainContent .media img, #MainContent img');
    var priceEl = document.querySelector('.price-item--regular');
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'card-save-btn mn-pdp-wishlist';
    b.setAttribute('data-product-id', m.id || '');
    b.setAttribute('data-variant-id', vEl ? vEl.value : '');
    b.setAttribute('data-product-title', titleEl ? titleEl.textContent.trim() : '');
    b.setAttribute('data-product-url', location.origin + location.pathname);
    b.setAttribute('data-product-image', imgEl ? (imgEl.currentSrc || imgEl.src) : '');
    b.setAttribute('data-product-price', priceEl ? priceEl.textContent.replace(/[^0-9.]/g, '') : '');
    b.setAttribute('aria-label', 'Add to wishlist');
    b.innerHTML = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41 .81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg><span class="mn-wl-text"></span>';
    return b;
  }
  function build() {
    if (!document.body || document.body.className.indexOf('template-product') === -1) return;
    var list = document.querySelectorAll('#MainContent .product-form__buttons');
    var btns = null;
    for (var i = 0; i < list.length; i++) { if (list[i].offsetParent !== null) { btns = list[i]; break; } }
    if (!btns) btns = list[0];
    if (!btns) return;
    var b = document.querySelector('.mn-pdp-wishlist') || makeBtn();
    if (b.parentElement !== btns.parentElement || b.previousElementSibling !== btns) {
      btns.parentNode.insertBefore(b, btns.nextSibling);
    }
    try { window.dispatchEvent(new CustomEvent('mrcn:wishlist-changed', { detail: {} })); } catch (e) {}
  }
  function run() { try { build(); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
  setTimeout(run, 600);
  setTimeout(run, 1500);
  document.addEventListener('shopify:section:load', run);
})();
